export default "/_next/static/images/modal5-5a7c6abaa36f867d2f9cf5ba71de3f7d.png";